import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAcneSevenGlyph from './svgs/AcneSevenGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var acneSevenGlyph = (props => useIcon(SvgAcneSevenGlyph, SvgAcneSevenGlyph, props));

export { acneSevenGlyph as default };
